import React, { useEffect } from 'react';
import { CheckCircle2 } from 'lucide-react';
import '../styles/Home.css';

const Goal = ({ goals }) => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          const items = entry.target.querySelectorAll('.goal-item');
          items.forEach((item, i) => {
            setTimeout(() => {
              item.classList.add('animate-in');
            }, i * 150);
          });
        }
      });
    }, { threshold: 0.2 });

    const section = document.querySelector('.goals-list');
    if (section) observer.observe(section);

    return () => observer.disconnect();
  }, []);

  return (
    <section className="goal section-padding-small">
      <div className="container">
        <div className="goal-content">
          <h2 className="heading-1">Cel projektu</h2>
          <div className="goals-list">
            {goals.map((goal, index) => (
              <div key={index} className="goal-item">
                <CheckCircle2 size={24} className="goal-icon" />
                <span className="body-regular">{goal}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Goal;
